// extracted by mini-css-extract-plugin
export var typingIndicator = "_q5-0";